import React, { ButtonHTMLAttributes } from 'react';
import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { rescheduleTheme } from '../rescheduleTheme';

const StyledPrimaryButton = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  minHeight: 52,
  padding: '0 28px',
  border: 'none',
  borderRadius: rescheduleTheme.radii.control,
  background: rescheduleTheme.brand,
  color: '#FFFFFF',
  fontFamily: 'inherit',
  fontSize: 17,
  fontWeight: 600,
  cursor: 'pointer',
  '&:hover:not(:disabled)': { background: rescheduleTheme.brandHover },
  '&:focus-visible': { outline: `2px solid ${rescheduleTheme.brand}`, outlineOffset: 2 },
  '&:disabled': {
    background: rescheduleTheme.disabledFill,
    color: rescheduleTheme.disabledText,
    cursor: 'not-allowed',
  },
});

type PrimaryButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { loading?: boolean };

export const PrimaryButton = ({ loading, disabled, children, type = 'button', ...buttonProps }: PrimaryButtonProps) => (
  <StyledPrimaryButton type={type} disabled={disabled || loading} aria-busy={loading || undefined} {...buttonProps}>
    {loading && <CircularProgress size={18} color="inherit" />}
    {children}
  </StyledPrimaryButton>
);
